module.exports = __webpack_public_path__ + "media/success.5348d726.wav";